import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-box',
  templateUrl: './info-box.component.html',
  styleUrls: ['./../app.component.css']
})
export class InfoBoxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
